<template>
  <b-modal
    v-model="isVisible"
    hide-footer
    size="lg"
    @hidden="onHidden"
  >
    <b-card>

      <LoadFileInput
        v-model="newFileConsentimiento"
        :label="'Consentimiento Informado'"
        :urlFile="urlConsentimiento"
      />

      <div class="d-flex justify-content-end">
        <b-button
          variant="primary"
          @click="onSaveConsentimiento()"
        >
          Guardar
        </b-button>
      </div>
      
      <hr>
    </b-card>
  </b-modal>
</template>

<script>
import { LoadFileInput } from '@/shared/components';
import { fileService }   from '@/shared/services';
import { atencionMedicaService } from '../../services';

export default {

  name: "AtencionModalUploads",

  components: {
    LoadFileInput
  },

  data() {
    return {
      isVisible: false,
      cedulaPaciente: null,

      tokenAtencion: null,
      urlConsentimiento: null,

      newFileConsentimiento: null
    }
  },

  created() {
    this.loadData();
  },


  methods: {
    async loadData() {

      this.tokenAtencion = this.$route.query.uploads_atencion;
      if(!this.tokenAtencion) return;

      const responseAtencion = await atencionMedicaService.getByToken(this.tokenAtencion);
      console.log('responseAtencion', responseAtencion);

      if(!responseAtencion){
        await this.$swal("Error", "La atencion no existe.", "error");
        this.backToUrl();
        return;
      }

      this.cedulaPaciente = responseAtencion.cita.paciente.persona.identificacion;
      this.urlConsentimiento = responseAtencion.urlConsentimiento;
      this.isVisible = true;
    },

    onHidden() {
      this.isVisible = false;
      this.newFileConsentimiento = null;
      this.urlConsentimiento = null;
    },

    async onSaveConsentimiento() {
      if(!this.newFileConsentimiento) return;

      const urlFile = await fileService.upload('consentimientos', this.newFileConsentimiento, this.cedulaPaciente, this.urlConsentimiento);

      if(!urlFile){
        await this.$swal("Error", "No se pudo guardar el consentimiento.", "error");
        return;
      }

      // actualizar la atencion
      const responseConsentimiento = await atencionMedicaService.uploadConsentimiento(this.tokenAtencion, urlFile);

      if(!responseConsentimiento){
        await this.$swal("Error", "No se pudo actualizar la atencion.", "error");
        return;
      }

      await this.$swal("Éxito", "Consentimiento guardado correctamente.", "success");
      this.onHidden();
    },


    backToUrl() {
      this.$router.push({ name: 'atenciones-medicas' });
    }
  },


  watch: {
    '$route.query.uploads_atencion': {
      handler(){ 
        this.loadData();
      },
    },

    isVisible: {
      deep: true,
      handler(newValue) {
        if( !newValue ) this.backToUrl();
      }
    },

    newFileConsentimiento: {
      deep: true,
      handler(newValue) {
        console.log('newFileConsentimiento', newValue);
      }
    }
  }
}
</script>
